var exports = {
  "kL": "xdbfd91f1--27193b--container",
  "nr": "xdbfd91f1--27193b--fat_panel",
  "YJ": "xdbfd91f1--27193b--fat_panel--old",
  "zC": "xdbfd91f1--27193b--images",
  "Ic": "xdbfd91f1--27193b--main_image",
  "cz": "xdbfd91f1--27193b--side_image",
  "I1": "xdbfd91f1--27193b--price_block",
  "CX": "xdbfd91f1--27193b--area_block",
  "h_": "xdbfd91f1--27193b--description",
  "LZ": "xdbfd91f1--27193b--full_link",
  "yJ": "xdbfd91f1--27193b--links",
};

module.exports = exports;
